


// Add View Collection Buttons depending on FB Ad Click
document.addEventListener('DOMContentLoaded', function() {
    // Capture query string and set cookies
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    
    urlParams.forEach((value, key) => {
        document.cookie = `${key}=${value}; path=/; SameSite=Lax`;
    });

    // Display query parameters dynamically
    const paramsContainer = document.getElementById('query-params');
    if (paramsContainer && queryString) {
        urlParams.forEach((value, key) => {
            const p = document.createElement('p');
            p.textContent = `${key}: ${value}`;
            paramsContainer.appendChild(p);
        });
    }

    // Update the button dynamically based on the `utm_campaign`
    const utmCampaign = urlParams.get('utm_campaign'); // Get the `utm_campaign` value
    const button = document.querySelector('.button-row__btn'); // Find the button
    const collection = document.querySelector('.tee-collection'); // Find the Title

    if (utmCampaign && button && collection) {
        const campaigns = {
            'yoga': { text: 'View All Yoga Tees', title: 'Yoga and Mindfulness', href: '/collections/yoga-and-mindfulness' },
            'new-yoga-arrivals': { text: 'View All Yoga Tees', title: 'Yoga and Mindfulness', href: '/collections/yoga-and-mindfulness' },
            'spirit-animals': { text: 'View All Spirit Animal Tees', title: 'Spirit Animals', href: '/collections/spirit-animals' },
            'animals': { text: 'View All Animal Tees', title: 'Animals and Wildlife', href: '/collections/animals-and-wildlife' },
            'christmas': { text: 'View All Christmas Tees', title: 'Christmas', href: '/collections/christmas' }
        };

        if (campaigns[utmCampaign]) {
            button.textContent = campaigns[utmCampaign].text;
            collection.textContent = campaigns[utmCampaign].title;
            button.href = campaigns[utmCampaign].href;
        } else {
            button.textContent = 'View All Tees';
            button.href = '/collections/t-shirts';
        }
    }
});

// Provide a Shipping Estimate
document.addEventListener("DOMContentLoaded", function() {
    // Function to add business days (excludes weekends)
    function addBusinessDays(startDate, daysToAdd) {
        let date = new Date(startDate);
        let addedDays = 0;
        while (addedDays < daysToAdd) {
            date.setDate(date.getDate() + 1);
            let dayOfWeek = date.getDay();
            if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Skip Sunday (0) and Saturday (6)
                addedDays++;
            }
        }
        return date;
    }

    // Define processing & shipping times in business days
    const processingTime = 3;  // Adjust based on Printify production time
    const shippingTime = 5;    // Adjust based on Printify shipping method

    // Get today's date
    const today = new Date();

    // Calculate estimated ship and delivery dates
    const shipDate = addBusinessDays(today, processingTime);
    const deliveryDate = addBusinessDays(shipDate, shippingTime);

    // Format dates
    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    const shipDateFormatted = shipDate.toLocaleDateString('en-US', options);
    const deliveryDateFormatted = deliveryDate.toLocaleDateString('en-US', options);

    // Display the estimate if the element exists
    const shippingEstimateElement = document.getElementById("shipping-estimate");
    if (shippingEstimateElement) {
        shippingEstimateElement.innerHTML = 
            `<p>The expected ship date of your order is <strong>${shipDateFormatted}</strong> and delivery date is by <strong>${deliveryDateFormatted}</strong>.</p>`;
    }
});

document.addEventListener('submit', function(e) {
  if (e.target.classList.contains('js-product-form')) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'custom_add_to_cart'
    });
  }
}, true);



